export const TagsSuggestions = [
  {
    label: 'Artists',
    value: 'Artists',
  },
  {
    label: 'AI',
    value: 'AI',
  },
  {
    label: 'BinanceSmartChain',
    value: 'BinanceSmartChain',
  },
  {
    label: 'Blockchains',
    value: 'Blockchains',
  },
  {
    label: 'CEXes',
    value: 'CEXes',
  },
  {
    label: 'Collections',
    value: 'Collections',
  },
  {
    label: 'Collectors',
    value: 'Collectors',
  },
  {
    label: 'DEXes',
    value: 'DEXes',
  },
  {
    label: 'Developers',
    value: 'Developers',
  },
  {
    label: 'Entertainment',
    value: 'Entertainment',
  },
  {
    label: 'Ethereum',
    value: 'Ethereum',
  },
  {
    label: 'Founders',
    value: 'Founders',
  },
  {
    label: 'Games',
    value: 'Games',
  },
  {
    label: 'Glossary',
    value: 'Glossary',
  },
  {
    label: 'Marketplaces',
    value: 'Marketplaces',
  },
  {
    label: 'Memecoins',
    value: 'Memecoins',
  },
  {
    label: 'Organizations',
    value: 'Organizations',
  },
  {
    label: 'PeopleInDeFi',
    value: 'PeopleInDeFi',
  },
  {
    label: 'Polkadot',
    value: 'Polkadot',
  },
  {
    label: 'Polygon',
    value: 'Polygon',
  },
  {
    label: 'Protocols',
    value: 'Protocols',
  },
  {
    label: 'Solana',
    value: 'Solana',
  },
  {
    label: 'Stablecoins',
    value: 'Stablecoins',
  },
  {
    label: 'Venture',
    value: 'Venture',
  },
]
